import { Button } from '@chakra-ui/react'
import dayjs from 'dayjs'
import { useState } from 'react'
import writeXlsxFile, { Row, SheetData } from 'write-excel-file'
import Download from '../../../../components/Icon/Download'
import { get } from '../../../../lib/http'
import controlStock from '../../utils/controlStock'
import { DownloadExcelProps, FindItem } from './types'

const head: (...values: string[]) => Row[number][] = (...values) =>
    values.map<Row[number]>(val => ({
        value: val,
        fontWeight: 'bold',
        wrap: true,
        alignVertical: 'center',
        align: 'left',
        fontSize: 11
    }))

export default function DownloadExcel({
    startDate,
    endDate
}: DownloadExcelProps) {
    const [isLoading, setIsLoading] = useState(false)

    async function load() {
        setIsLoading(true)
        const sDate = dayjs(startDate).format('DD/MM/YYYY')
        const eDate = dayjs(endDate).format('DD/MM/YYYY')
        const { data: items } = await get<FindItem[]>(
            `/api/items?&search=&start_date=${dayjs(
                startDate
            ).toISOString()}&end_date=${dayjs(endDate).toISOString()}`
        )

        const rows: SheetData = [
            [],
            [
                {
                    value: 'Kardex',
                    fontWeight: 'bold',
                    span: 5,
                    alignVertical: 'center',
                    align: 'center',
                    fontSize: 16
                }
            ],
            [
                {
                    value: `De: ${sDate} - Hasta ${eDate}`,
                    span: 5,
                    align: 'center'
                }
            ],
            [],
            head(
                'Producto',
                'Stock Inicial',
                'Ingresos',
                'Salidas',
                'Stock Final'
            )
        ]

        items.result.forEach(item => {
            const { initialQuantity, input, output, finalStock } =
                controlStock(item)

            rows.push([
                {
                    value: item.name,
                    type: String
                },
                {
                    value: initialQuantity,
                    type: Number
                },
                {
                    value: input,
                    type: Number
                },
                {
                    value: output,
                    type: Number
                },
                {
                    value: finalStock,
                    type: Number
                }
            ])
        })

        await writeXlsxFile(rows, {
            fileName: `kardex_${sDate}_${eDate}.xlsx`,
            columns: [30, 12, 12, 12, 12].map(width => ({ width })),
            fontSize: 10
        })

        setIsLoading(false)
    }

    return (
        <Button
            variant="alo-gray:md-md"
            type="submit"
            rightIcon={<Download fill="white" />}
            onClick={load}
            isLoading={isLoading}
        >
            Exportar a Excel
        </Button>
    )
}
